/* import __COLOCATED_TEMPLATE__ from './user-profile-avatar.hbs'; */
import Component, { setComponentTemplate } from "@ember/component";
import TEMPLATE from "./user-profile-avatar.hbs";
export default setComponentTemplate(TEMPLATE, Component.extend({}));